<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-bar" />
  </div>
</template>

<script>
export default {
  name: "LoadingBar",
  props: { isLoading: Boolean },
};
</script>
